import { CSSProperties, ReactNode } from "react";

export enum BannerPlatform {
  Web = 'web',
  Mobile = 'mobile',
  Tablet = 'tablet',
  TV = 'tv',
}

export enum BannerSegment {
  Freemium = 'freemium',
  Subscriber = 'subscriber',
}

export enum BannerSlot {
  Top = 'top',
  Middle = 'middle',
  Bottom = 'bottom',
}

export const platformLabels: Record<BannerPlatform, string> = {
  [BannerPlatform.Web]: 'Plataforma Web',
  [BannerPlatform.Mobile]: 'Mobile',
  [BannerPlatform.Tablet]: 'Tablet',
  [BannerPlatform.TV]: 'TV',
};

export const segmentLabels: Record<BannerSegment, string> = {
  [BannerSegment.Freemium]: 'Freemium',
  [BannerSegment.Subscriber]: 'Assinante',
};

export const slotLabels: Record<BannerSlot, string> = {
  [BannerSlot.Top]: 'Topo',
  [BannerSlot.Middle]: 'Meio',
  [BannerSlot.Bottom]: 'Fundo',
};

export interface BannerConfiguration {
  platform: BannerPlatform | null;
  segment: BannerSegment | null;
  slot: BannerSlot | null;
}

export interface BannerFormData {
  configuration: BannerConfiguration;
}

export enum BannerDestinationType {
  Link = 'link',
  Product = 'product',
  Category = 'category',
}

export interface BannerImageValue {
  file?: File;
  preview?: string;
  name?: string;
}

export type BannerImageFieldPath =
  | 'content.images.web'
  | 'content.images.tablet'
  | 'content.images.mobile'
  | 'content.images.single';

export interface BannerImageUploadDefinition {
  label: string;
  width: number;
  height: number;
  fieldPath: BannerImageFieldPath;
}

export enum BannerStatusEnum {
  Active = 'activated',
  Inactive = 'inactivated',
  Draft = 'draft',
  Scheduled = 'scheduled',
}

export enum DeviceTypeEnum {
  WEB = 'web',
  MOBILE = 'mobile',
  TABLET = 'tablet',
  TV = 'tv',
}
export interface BannerManagementItem {
  id: number;
  title: string;
  segment: BannerSegment;
  slotType: BannerSlot;
  startDate: string;
  endDate: string;
  status: BannerStatusEnum;
  devices: DeviceTypeEnum[];
  createdAt: string;
}

export interface BannerManagementFilters {
  segment?: BannerSegment;
  slotType?: BannerSlot;
  status?: BannerStatusEnum;
}

export interface BannerApiItem {
  id: number;
  title: string;
  effectiveDate: string;
  expirationDate: string | null;
  deviceType: DeviceTypeEnum;
  slotType: BannerSlot;
  targetMarket: BannerSegment;
  status: BannerStatusEnum;
  order: number;
  link: string;
  productId: number;
  categoryId: number;
  images?: {
    bottom?: string;
    middle?: string;
    web?: string;
    mobile?: string;
    tablet?: string;
  };
  createdAt?: string;
}

export interface BannerListParams {
  page?: number;
  limit?: number;
  title?: string;
  status?: BannerStatusEnum;
  deviceType?: DeviceTypeEnum;
  slotType?: BannerSlot;
  targetMarket?: BannerSegment;
  startDate?: string;
  endDate?: string;
}

export interface BannerListResponse {
  data: BannerApiItem[];
  total: number;
}

export interface BannerOrderParams {
  deviceType: DeviceTypeEnum;
  slotType: BannerSlot;
  targetMarket: BannerSegment;
}

export interface BannerOrderItem {
  id: number;
  order: number;
  title: string;
}

export interface BannerOrderUpdatePayload {
  banners: Array<{
    id: number;
    order: number;
  }>;
}

export interface BannerStatusTagProps {
  status: BannerStatusEnum;
}

export interface StatusTagConfig {
  icon: ReactNode;
  label: string;
  style: CSSProperties;
}
